import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Analytics from '../Analytics';
import PWAInstallPrompt from '../PWAInstallPrompt';

/**
 * Rola suavemente para o elemento indicado pelo hash da URL (ex.: /#modules),
 * inclusive quando se navega de outra rota para a home — aguarda o conteúdo
 * lazy montar antes de rolar.
 */
const ScrollToHash: React.FC = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      // Conteúdo lazy pode não ter montado ainda — tenta por ~1,5s
      if (tries++ < 30) {
        timer = window.setTimeout(tryScroll, 50);
      }
    };

    tryScroll();
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [hash, pathname]);

  return null;
};

const RootLayout: React.FC = () => {
  return (
    <>
      <ScrollToHash />
      <Analytics />
      <Outlet />
      <PWAInstallPrompt />
    </>
  );
};

export default RootLayout;
